if (!customElements.get('pdp-v2-sticky-atc')) {
  customElements.define(
    'pdp-v2-sticky-atc',
    class PdpV2StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.pdp-v2-sticky-atc__btn');
        this.colours = this.querySelector('.pdp-v2-sticky-atc__colours');
        this.target = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        if (!this.target || !this.button) return;

        this.observer = new IntersectionObserver(
          ([entry]) => this.setVisible(!entry.isIntersecting),
          { threshold: 0 }
        );
        this.observer.observe(this.target);

        const gallery = this.closest('product-info')?.querySelector('.pdp-v2__media');
        if (this.colours && gallery) {
          // Bottom margin so the gallery counts as "passed" once it slides behind the sticky bar
          this.galleryObserver = new IntersectionObserver(
            ([entry]) => this.setColoursVisible(entry.isIntersecting),
            { threshold: 0, rootMargin: '0px 0px -120px 0px' }
          );
          this.galleryObserver.observe(gallery);
        }

        this.button.addEventListener('click', this.onClick);
        document.addEventListener('product-ajax:added', this.onDone);
        document.addEventListener('product-ajax:error', this.onDone);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.galleryObserver?.disconnect();
        this.button?.removeEventListener('click', this.onClick);
        document.removeEventListener('product-ajax:added', this.onDone);
        document.removeEventListener('product-ajax:error', this.onDone);
        document.body.classList.remove('pdp-v2-sticky-atc-visible');
      }

      setVisible(visible) {
        this.visible = visible;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.button.tabIndex = visible ? 0 : -1;
        document.body.classList.toggle('pdp-v2-sticky-atc-visible', visible);
        this.updateColoursFocus();
      }

      setColoursVisible(visible) {
        this.coloursVisible = visible;
        this.classList.toggle('has-colours', visible);
        this.updateColoursFocus();
      }

      updateColoursFocus() {
        if (!this.colours) return;
        const focusable = this.visible && this.coloursVisible;
        this.colours.querySelectorAll('.pdp-v2-colours__link').forEach((link) => {
          link.tabIndex = focusable ? 0 : -1;
        });
      }

      onClick = () => {
        if (this.button.disabled) return;
        this.button.classList.add('is-loading');
        clearTimeout(this.loadingTimer);
        this.loadingTimer = setTimeout(this.onDone, 8000);
      };

      onDone = () => {
        clearTimeout(this.loadingTimer);
        this.button?.classList.remove('is-loading');
      };
    }
  );
}
